define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FAssetAttrTypeVal = void 0;
    class FAssetAttrTypeVal extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "AttrTypeId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AttrTypeIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Value", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ValueError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetAttrType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FAssetAttrTypeVal.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FAssetAttrType = parent;
            this.AttrTypeId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.FAssetAttrType = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.AttrTypeId = (0, EntityUtil_1.toInt)(entity.AttrTypeId);
            a.Value = b.Value;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FAssetAttrTypeVal.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "AttrTypeId", "Attribute Type Id");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                AttrTypeId: this.AttrTypeId,
                Value: this.Value,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.FAssetAttrTypeVal = FAssetAttrTypeVal;
    Object.defineProperty(FAssetAttrTypeVal, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FAssetAttrTypeVal"
    });
    Object.defineProperty(FAssetAttrTypeVal, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Asset Attribute Type Value"
    });
    Object.defineProperty(FAssetAttrTypeVal, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "AttrTypeId", "Value"]
    });
    Object.defineProperty(FAssetAttrTypeVal, "AttrTypeIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAssetAttrTypeVal, "ValueLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FAssetAttrTypeVal, "ValueReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrTypeVal.prototype, "AttrTypeId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrTypeVal.prototype, "AttrTypeIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrTypeVal.prototype, "Value", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrTypeVal.prototype, "ValueError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrTypeVal.prototype, "FAssetAttrType", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FAssetAttrTypeVal.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FAssetAttrTypeVal.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FAssetAttrTypeVal.prototype, "merge", null);
});
